import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { FunnelIntakeAnswers } from "../models";

export interface FunnelDateOfBirth {
  month?: string;
  day?: string;
  year?: string;
}

/**
 * State for the levelsRx-style funnel. Measurements/DOB/sex mirror the questionnaire
 * store, and the answers to the backend intake screens are kept by question key
 * so they can be submitted at checkout as the funnel answers.
 */
export interface FunnelStore {
  // Start
  heightFeet?: number;
  heightInches?: number;
  initialWeight?: number;
  expectedWeight?: number;
  dateOfBirth?: FunnelDateOfBirth;
  sex?: string;

  // Backend intake screens
  intakeAnswers?: FunnelIntakeAnswers;

  // Eligibility
  firstName?: string;
  lastName?: string;
  state?: string;
  email?: string;
  phone?: string;

  set: (values: Partial<FunnelStore>) => void;
  reset: VoidFunction;
}

const INITIAL_STATE = {
  heightFeet: undefined,
  heightInches: undefined,
  initialWeight: undefined,
  expectedWeight: undefined,
  dateOfBirth: undefined,
  sex: undefined,
  intakeAnswers: undefined,
  firstName: undefined,
  lastName: undefined,
  state: undefined,
  email: undefined,
  phone: undefined,
} satisfies Partial<FunnelStore>;

export const useFunnelStore = create<FunnelStore>()(
  persist(
    (set) => ({
      set: (values) => set(values),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: "funnel-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
